module.exports = __webpack_public_path__ + "fonts/TradeGothicLTStd-Light.8e63223.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TradeGothicLTStd-Light.otf
// module id = ./src/assets/fonts/TradeGothicLTStd-Light.otf
// module chunks = 34